<template>
  <vs-popup
    title="Agendamento de envio"
    :active.sync="opened"
    v-on:close="onClose"
    class="sizePopup">
    <div class="vx-col w-full mb-base">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span">E-mail</span>

            <vs-input
              v-model="email"
              class="w-full"
              name="email"
              v-validate="'required|email'"
            />

            <div class="clear: both;">
              <span
                class="text-danger text-sm"
                v-show="errors.has('email')"
              >
                {{ errors.first('email') }}
              </span>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="w-12/12">
              <div class="w-full">
                <vs-button class="mt-5" @click="generateSheet">
                  Agendar
                </vs-button>
              </div>
            </div>
          </div>

        </div>
    </div>
  </vs-popup>
</template>

<script>

export default {
  name: 'ReportBookingModal',
  data() {
    return {
      email: '',
      opened: false
    }
  },
  created () {
    this.$parent.$on('openReportBookingModal', () => {
      this.opened = true;
    });
  },
  methods: {
    onClose() {
      this.opened = false;
      this.errors.clear();
      this.$validator.reset();
    },
    generateSheet() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this.$emit('scheduleReport', this.email);
        this.opened = false;
        this.errors.clear();
        this.$validator.reset();
        this.email = '';
      });
    }
  }
}

</script>

<style lang="scss">
</style>
